
<template>
  <div id="app">
    <Navbar/>
    <div class="container-main">
      <Modal v-model="loading" title="Cargando">
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </Modal>
      <div class="row">
        <div class="card element-main" style="width: 18rem;">
          <img class="card-img-top" src="@/assets/images/curso-online.png" alt="Card image cap">
          <div class="card-body">
            <h5 class="card-title">Capacitacion</h5>
            <div v-if="isCourse" class="progress">
              <div  class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="{width : progressCourse.toString()+'%'}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <p class="card-text">Mediante tareas sencillas, Ingresa al mundo de la programcion.</p>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item">Ejercisios Dinamicos</li>
            <li class="list-group-item">Sintaxis Sencilla</li>
            <li class="list-group-item">Aprendizaje continuo</li>
          </ul>
          <div class="card-body">
            <Modal v-model="activeModal" title="Iniciar Curso">
              <p v-html="'El siguiente curso consta de actividades que se convertiran en un primer paso al mundo de la programacíon'"></p>
              <p>Fue hecho con mucho cariño espero que lo disfrutes</p>
              <p>Una ves finalizado el curso puedes obtener tu certificado</p>
              <p>Buena Suerte</p>


              <button type="button" class="btn btn-primary" @click="subscribeCourse()">
                Iniciar
              </button>
            </Modal>
            <button v-if="!isCourse" type="button" class="btn btn-primary" @click="activeModal=true">
              Inscribirse
            </button>
            <button v-if="isCourse" type="button" class="btn btn-primary" @click="completeCourse()">
              Continuar
            </button>
            <button v-if="certPath!=='empty'&&!loading" type="button" class="btn btn-success" @click="goToPath('/certificate/'+certPath)">
              Continuar
            </button>

          </div>
        </div>
        <div class="card element-main" style="width: 18rem;">
          <img class="card-img-top" src="@/assets/images/EditorCode.png" alt="Card image cap">
          <div class="card-body">
            <h5 class="card-title">Editor de Código</h5>
            <p class="card-text">Aprender a programar nunca fue tan facil.</p>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item">Diseño Amigable</li>
            <li class="list-group-item">Sintaxis Sencilla</li>
            <li class="list-group-item">Ejecucion Online</li>
          </ul>
          <div class="card-body">
            <a href="#/code/edit" class="card-link">Iniciar</a>
            <a href="#/docs" class="card-link">Revisar Documentacion</a>
          </div>
        </div>
        <div class="card element-main" style="width: 18rem;">
          <img class="card-img-top" src="@/assets/images/more.png" alt="Card image cap">
          <div class="card-body">
            <h5 class="card-title">Muy Prontoo</h5>
            <p class="card-text">Tenemos muchas sorpresas preparados para ti.</p>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item">Diseño Amigable</li>
            <li class="list-group-item">Sintaxis Sencilla</li>
            <li class="list-group-item">Ejecucion Online</li>
          </ul>
          <div class="card-body">
          </div>
        </div>

      </div>
    </div>



  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import constants from "@/utils/constants";
import {isEmpty} from "lodash";
import Navbar from "@/components/Navbar";
export default {
  name: 'Dashboard',
  components:{
    Navbar

  },
  data() {
    return {
      user:{},
      course:{},
      isCourse:false,
      activeModal:false,
      progressCourse:0,
      courseLength:0,
      isLogin:false,
      certPath:'empty',
      loading:false,
    }
  },
  methods:{
    getUserLogin: function() {
      const userAuth =  JSON.parse(store.getters.getJWT);
      const bodyParameters = {
        email: userAuth.email
      };
      this.loading=true;
      axios.post(constants.endpointList.getUser,
          bodyParameters,
      ).then((result)=>{
        this.$store.dispatch('setLogin',true);

        this.$store.dispatch('setUser', JSON.stringify(result.data))
        this.user=result.data;
        this.loading=false;
        this.getStudentCourse();

      }).catch((error)=>{
        this.loading=false;
        console.log(error);
      });

    },
    getStudentCourse:function (){
      this.loading=true;
      const bodyParameters = {
        userId: this.user.id,
      };
      axios.post(constants.endpointList.courseStatus,
          bodyParameters,
      ).then((result)=>{
        this.loading=false;
        this.course=result.data
        if(!isEmpty(this.course)){
          this.progressCourse=this.course.percentProgress;
          this.courseLength=this.course.length;
          this.certPath = this.course.certificatePath;
          this.isCourse=true;
        }
      }).catch((error)=>{
        this.loading=false;
        console.log(error);
      });

    },
    getWelcome:function (){
      return `Bienvenido ${this.user.displayName}`;
    },



    logout: function (){
      this.$store.dispatch('setUser',{});
      this.$store.dispatch('setJWT',{});
      this.$router.push('/');
    },
    subscribeCourse:function (){
      this.loading=true;
      const bodyParameters = {
        userId: this.user.id,
        name:this.user.name,
      };
      axios.post(constants.endpointList.subscribeCourse,
          bodyParameters,
      ).then(()=>{
        this.loading=false;
        this.$router.push('/course/code/edit');
      }).catch((error)=>{
        this.loading=false;
        console.log(error);
      });

    },
    completeCourse:function (){
      this.$router.push('/course/code/edit');
    },
    goToPath:function (path){
      this.$router.push(path);

    }
  },
  created: function(){
    this.isLogin = this.$store.getters.isLogin;
    if(this.isLogin){
      this.getUserLogin();
    }else{
      this.$router.push('/login');
    }
  }

}
</script>
<style scoped>
.header {
  text-align: center;
  padding: 1rem;
}
.logo {
  width: 80px;
}
.title{
  color: black;
}
.container-header {
  margin-left: 100px;
  padding: 20px;
  display: flex !important;
  align-items: center !important;
}
.container-main{
  padding: 50px;
}
.element-main{
  margin-left: 10px;
  margin-top: 10px;
}
.images{
  margin-left: 40px;
  height: 25%;
  width: 25%;
}
</style>
